import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-wallet-dialog-unverified',
  templateUrl: './wallet-dialog-unverified.component.html',
})
export class WalletDialogUnverifiedComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<WalletDialogUnverifiedComponent>
  ) {}

  ngOnInit(): void {}
}
